import React, { memo } from 'react';
import PropTypes from 'prop-types';
import PublicRoute from './PublicRoute';
import { PageSuspense } from './pages';

function PublicPage({ component, lazy = true }) {
  return lazy ? (
    <PublicRoute>
      <PageSuspense>{component}</PageSuspense>
    </PublicRoute>
  ) : (
    <PublicRoute>{component}</PublicRoute>
  );
}

PublicPage.propTypes = {
  component: PropTypes.element,
  lazy: PropTypes.bool,
};

export default memo(PublicPage);
